function ctlFormatMoney(cents, format) {
  if (typeof cents !== 'number' || isNaN(cents)) return '';

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    const negative = number < 0;
    number = Math.abs(number / 100.0).toFixed(precision);
    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return (negative ? '-' : '') + dollarsAmount + centsAmount;
  }

  const formatString = format || '\u007B\u007Bamount\u007D\u007D';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const match = formatString.match(placeholderRegex);
  let value = '';

  switch (match ? match[1] : 'amount') {
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return match ? formatString.replace(placeholderRegex, value) : value;
}

if (!customElements.get('complete-the-look')) {
  customElements.define(
    'complete-the-look',
    class CompleteTheLook extends HTMLElement {
      connectedCallback() {
        this.moneyFormat = this.dataset.moneyFormat || '\u007B\u007Bamount\u007D\u007D';
        this.cards = Array.from(this.querySelectorAll('[data-ctl-index]'));
        this.state = {};

        this.cards.forEach((card) => {
          const index = card.dataset.ctlIndex;
          if (this.state[index]) return;

          const variantsScript = card.querySelector('[data-ctl-role="variants"]');
          const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
          const initialCheckbox = card.querySelector('[data-ctl-role="checkbox"]');

          this.state[index] = {
            variants,
            checked: !!(initialCheckbox && initialCheckbox.checked),
            currentVariant: variants.find((v) => v.available) || variants[0] || null,
          };
        });

        this.totalEl = this.querySelector('[data-ctl-role="total"]');
        this.buttonEl = this.querySelector('[data-ctl-role="submit"]');
        this.errorEl = this.querySelector('[data-ctl-role="error"]');

        this.addEventListener('change', this.handleChange.bind(this));
        if (this.buttonEl) {
          this.buttonEl.addEventListener('click', this.handleSubmit.bind(this));
        }

        this.sliderEl = this.querySelector('.wt-ctl__cards--slider');
        this.dotsEl = this.querySelector('[data-ctl-role="dots"]');
        if (this.sliderEl && this.dotsEl) {
          this.setupDots();
          this.sliderEl.addEventListener('scroll', this.handleSliderScroll.bind(this), { passive: true });
          window.addEventListener('resize', this.setupDots.bind(this));
        }

        this.updateSummary();
      }

      setupDots() {
        if (!this.sliderEl || !this.dotsEl) return;

        const pages = Math.max(1, Math.round(this.sliderEl.scrollWidth / this.sliderEl.clientWidth));
        this.pages = pages;
        this.dotsEl.innerHTML = '';
        this.dots = [];

        if (pages <= 1) return;

        for (let i = 0; i < pages; i += 1) {
          const dot = document.createElement('span');
          dot.className = 'wt-ctl__dot' + (i === 0 ? ' is-active' : '');
          this.dotsEl.appendChild(dot);
          this.dots.push(dot);
        }
      }

      handleSliderScroll() {
        if (!this.dots || !this.dots.length) return;
        if (this._scrollRaf) return;

        this._scrollRaf = requestAnimationFrame(() => {
          this._scrollRaf = null;

          const maxScroll = this.sliderEl.scrollWidth - this.sliderEl.clientWidth;
          const ratio = maxScroll > 0 ? this.sliderEl.scrollLeft / maxScroll : 0;
          const index = Math.round(ratio * (this.pages - 1));

          this.setActiveDot(index);
        });
      }

      setActiveDot(index) {
        if (!this.dots) return;
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }

      handleChange(event) {
        const target = event.target;
        const role = target.dataset.ctlRole;
        if (role !== 'checkbox' && role !== 'select') return;

        const wrapper = target.closest('[data-ctl-index]');
        if (!wrapper) return;
        const index = wrapper.dataset.ctlIndex;
        const state = this.state[index];
        if (!state) return;

        if (role === 'checkbox') {
          state.checked = target.checked;
          this.syncGroup(index, 'checkbox', target.checked);
          this.toggleUnselectedClass(index, !target.checked);
        }

        if (role === 'select') {
          const variant = state.variants.find((v) => v.value === target.value);
          if (variant) {
            state.currentVariant = variant;
            this.updateCardPrice(index, variant);
            this.syncGroup(index, 'select', target.value);
          }
        }

        this.updateSummary();
      }

      syncGroup(index, role, value) {
        this.querySelectorAll(`[data-ctl-index="${index}"] [data-ctl-role="${role}"]`).forEach((el) => {
          if (role === 'checkbox') {
            el.checked = value;
          } else {
            el.value = value;
          }
        });
      }

      toggleUnselectedClass(index, isUnselected) {
        this.querySelectorAll(`.wt-ctl__card[data-ctl-index="${index}"], .wt-ctl__list-row[data-ctl-index="${index}"]`).forEach((el) => {
          el.classList.toggle('is-unselected', isUnselected);
        });
      }

      updateCardPrice(index, variant) {
        const compareText = variant.compareAtPrice ? variant.compareAtPrice : '';
        this.querySelectorAll(`[data-ctl-index="${index}"] [data-ctl-role="compare"]`).forEach((el) => {
          el.textContent = compareText;
          el.hidden = !compareText;
        });
        this.querySelectorAll(`[data-ctl-index="${index}"] [data-ctl-role="final"]`).forEach((el) => {
          el.textContent = variant.price;
        });
      }

      updateSummary() {
        let totalCents = 0;
        let count = 0;

        Object.keys(this.state).forEach((index) => {
          const state = this.state[index];
          if (state.checked && state.currentVariant) {
            totalCents += state.currentVariant.priceCents;
            count += 1;
          }
        });

        if (this.totalEl) {
          this.totalEl.textContent = ctlFormatMoney(totalCents, this.moneyFormat);
        }

        if (this.buttonEl) {
          if (count === 0) {
            this.buttonEl.textContent = this.buttonEl.dataset.labelEmpty || 'Sélectionner un produit';
            this.buttonEl.setAttribute('aria-disabled', 'true');
          } else {
            const label = this.buttonEl.dataset.labelTemplate || 'Ajouter les %%COUNT%% au panier';
            this.buttonEl.textContent = label.replace('%%COUNT%%', count);
            this.buttonEl.removeAttribute('aria-disabled');
          }
        }
      }

      handleSubmit() {
        if (this.buttonEl.getAttribute('aria-disabled') === 'true') return;

        const items = Object.keys(this.state)
          .map((index) => this.state[index])
          .filter((state) => state.checked && state.currentVariant && state.currentVariant.available)
          .map((state) => ({ id: state.currentVariant.id, quantity: 1 }));

        if (items.length === 0) return;

        if (this.errorEl) {
          this.errorEl.classList.remove('is-visible');
          this.errorEl.textContent = '';
        }

        this.buttonEl.classList.add('loading');
        this.buttonEl.setAttribute('aria-disabled', 'true');

        const cartDrawer = document.querySelector('cart-drawer');
        const sections =
          cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
            ? cartDrawer.getSectionsToRender().map((section) => section.id)
            : [];

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items,
            sections,
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (this.errorEl) {
                this.errorEl.textContent = response.description || response.message || '';
                this.errorEl.classList.add('is-visible');
              }
              return;
            }

            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'complete-the-look',
                cartData: response,
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.buttonEl.classList.remove('loading');
            this.updateSummary();
          });
      }
    },
  );
}
